<template>
  <router-view />
</template>
<script>
export default {
  name: 'Entrepreneurship',
};
</script>
